export default __webpack_public_path__ + "static/developer_mobile-ba93c4a2c71e0763b6abe2a2de043628.png";